import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

const EvidencePage = lazy(() => import("@/features/dashboard/pages/evidence"));

export const Route = createFileRoute("/(app)/dashboard/evidence")({
  component: () => (
    <Suspense fallback={<div className="text-muted-foreground text-sm">Loading Evidence Vault...</div>}>
      <EvidencePage />
    </Suspense>
  ),
});
